import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import imagefallback from '@loyal_images/products/product_placeholder.png'
import { Link } from 'react-router-dom'
import ReactImageFallback from 'react-image-fallback'
import { Status, Name } from './Status'
import { ProductShipping } from '../../../../Participant/MyOrders/ProductOrderDetail/ProductSide'
class Item extends Component {
  render () {
    let { order, tracking } = this.props
    let statuses = null
    if (tracking && tracking.statuses) statuses = tracking.statuses
    else {
      statuses = [
        {
          status: '1',
          name: 'Produto solicitado',
          when: order.insertDate
        }
      ]
    }

    let lastTrackingStatus = statuses.slice(-1)
    lastTrackingStatus = lastTrackingStatus && lastTrackingStatus[0]

    let statusTracking = null
    if (order.trackingVtexId) {
      statusTracking = (
        <ProductShipping
          trackingVtexData={{
            courier: this.props.order.trackingVtexCourier,
            trackingNumber: this.props.order.trackingVtexNumber
          }}
        />
      )
    } else if (statuses) {
      statusTracking = (
        <ul className='tracking-steps col-12 px-0'>
          {statuses.map((status, index) => (
            <Status status={status} index={index} />
          ))}
        </ul>
      )
    }

    return (
      <Fragment>
        <div className='col-12 px-1 order-item '>
          <Link
            className='mx-0 row px-0 py-2'
            to={`/order/${order.parentOrderId}/${order.orderId}/product/${order.id}`}
          >
            <div className='mx-0 row px-0 border-color-ui-3 border-dotted-bottom pb-2'>
              <div className='order-img col-3 txt-center pl-0 pr-2'>
                <div className='row align-items-center h-100'>
                  <div className='col-12 px-0 txt-center'>
                    <ReactImageFallback
                      src={order.productImageUrl}
                      fallbackImage={imagefallback}
                      initialImage={imagefallback}
                      alt={order.productName}
                      className='img-w-auto'
                    />
                  </div>
                </div>
              </div>
              <div className='order-product-info col mr-auto'>
                <div className='order-product-info row'>
                  <div className='product-infos col-12 mx-0'>
                    <div className='row'>
                      <div className='col py-half px-0'>
                        {(lastTrackingStatus && (
                          <Name
                            className='txt-font-body ptxt-subtitle color-ui-2 mt-1'
                            {...lastTrackingStatus}
                          />
                        )) ||
                          ''}
                        <p className='txt-font-body txt-subtitle color-ui-2 mt-1'>
                          {order.productName}
                        </p>
                        <p className='txt-font-body txt-subtitle color-brand-1 pt-half d-none'>
                          Já recebi o produto
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>
        {statusTracking}
      </Fragment>
    )
  }
}

Item.propTypes = {
  order: PropTypes.object,
  tracking: PropTypes.object,
  insertNetshoesLastEvent: PropTypes.func
}

export default Item



// WEBPACK FOOTER //
// ./src/App/Header/Tracking/Item/Item.js